function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "02a_Dashboard_Green",
  transform: "translate(-582.000000, -104.000000)",
  stroke: "#327954"
}, /*#__PURE__*/React.createElement("g", {
  id: "copy-copy",
  transform: "translate(583.000000, 105.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 4.25,
  y: 4.25,
  width: 9.75,
  height: 9.75,
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.25,9.75 L1.5,9.75 C0.671572875,9.75 0,9.07842712 0,8.25 L0,1.5 C0,0.671572875 0.671572875,0 1.5,0 L8.25,0 C9.07842712,0 9.75,0.671572875 9.75,1.5 L9.75,2.25",
  id: "Path"
}))));

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09666F80-C3B8-46ED-B8C7-B384D4ABBFE5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.10a7d391.svg";
export { ForwardRef as ReactComponent };